<label *ngIf="label"
    [attr.for]="id"
    soho-label
    [required]="isRequired"
    lm-label
      [layoutField] = "field"
      [personalize]="personalize"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
>{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}</label>
<lm-lpl-editor-compare #LplEditorCompare
    soho-alert
    soho-trackdirty
    [original]="compareLpl"
    [lpl]="editorLpl"
    [validationOptions]="editorValidationOptions"
    [readonly]="isReadOnly || displayAsText"
    (lplChangedEvent)="onLplChangedEvent($event)"
    (blur)="onBlur($event)"
    (change)="onChange()"
    (input)="onInput($event)"
></lm-lpl-editor-compare>
